<div class="list-item-display">
  <div class="list-item-content">
    <div class="list-item-text">
      @if (showModified && oldTitle !== undefined && newTitle !== undefined) {
        <div class="list-item-title-diff">
          <div class="list-item-title removed">{{ oldTitle }}</div>
          <div class="list-item-title added">{{ newTitle }}</div>
        </div>
      } @else {
        <div class="list-item-title" [class]="valueClass">{{ title }}</div>
      }
      @if (showDiff && oldValue !== undefined && newValue !== undefined) {
        <div class="list-item-diff">
          <div class="list-item-value removed">
            {{ oldValue }}
            @if (oldDetails) {
              <div class="list-item-details">{{ oldDetails }}</div>
            }
          </div>
          <div class="list-item-value added">
            {{ newValue }}
            @if (newDetails) {
              <div class="list-item-details">{{ newDetails }}</div>
            }
          </div>
        </div>
      } @else {
        <div class="list-item-value" [class]="valueClass">
          {{ value }}
          @if (details) {
            <div class="list-item-details">{{ details }}</div>
          }
        </div>
      }
    </div>
    @if (icon) {
      <mat-icon class="list-item-icon">{{ icon }}</mat-icon>
    }
  </div>
</div> 